import { render, staticRenderFns } from "./TextNotMaintained.vue?vue&type=template&id=2b766568&scoped=true&"
import script from "./TextNotMaintained.vue?vue&type=script&lang=js&"
export * from "./TextNotMaintained.vue?vue&type=script&lang=js&"
import style0 from "./TextNotMaintained.vue?vue&type=style&index=0&id=2b766568&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b766568",
  null
  
)

export default component.exports